module.exports = __webpack_public_path__ + "media/images/emoticons/rock-05409c2a2aee6c265bcc8a3dd1626cd5.gif";